import { Component, OnInit } from '@angular/core';
import { ColumnMode, SelectionType, SortType } from '@swimlane/ngx-datatable';
import { DataService } from 'src/app/data.service';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, EMPTY, firstValueFrom, retry, throwError } from 'rxjs';
import { kirBeolvas, kirDatum, KirOlvasas } from '../kir-import';

@Component({
  selector: 'app-importtanulok',
  templateUrl: './importtanulok.component.html',
  styleUrls: ['./importtanulok.component.scss'],
})
export class ImporttanulokComponent implements OnInit {

  excelData: any[];
  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;
  protected readonly SelectionType = SelectionType;
  allomany
  overwrite = false
  generateKeycloakImport = false
  cdis = false;
  uploading = false;
  sajatIntezmeny
  osztaly
  hibassorok=[]
  ellenorzes: { rendben: number; hianyos: number; blokkolt: number; letezo: number; tetelek: any[] } = null;
  eredmeny: any = null;

  /* ── ENTRA (Azure AD) CSV: az e-mail címek forrása ──────────────────────
   *
   *  A KIR-export NEM tartalmaz e-mail címet – az csak az Entrában van meg. A kettőt
   *  az OKTATÁSI AZONOSÍTÓ köti össze. Ide töltjük be az Entra felhasználó-exportot,
   *  és a rendszer összefésüli a KIR-sorokkal.
   *
   *  Az oszlopokat megpróbáljuk kitalálni (melyikben van az azonosító, melyikben az
   *  e-mail), de kézzel felül lehet bírálni: az Entra-export oszlopnevei bérlőnként
   *  eltérnek, és egy rossz tipp itt csendben rossz e-mailt adna a gyereknek.
   */
  entraSorok: any[] = [];
  entraOszlopok: string[] = [];
  entraFajlNev = '';
  entraOktazonOszlop = '';
  entraEmailOszlop = '';
  entraTelefonOszlop = '';
  /*  NÉVRE ILLESZTÉS.
   *
   *  A gyakorlatban az Entra-bérlőben NINCS oktatási azonosító – se `employeeId`, se
   *  extension-mező –, tehát az azonosító-alapú összekötés ott sosem talál semmit.
   *  Ilyenkor a NÉV az egyetlen kapocs. Ez viszont önmagában kockázatos: két azonos
   *  nevű gyerek e-mail címét felcserélve az egyik család a másik adatait kapná meg.
   *  Ezért csak akkor fogadjuk el, ha a találat EGYÉRTELMŰ – egyetlen jelölt van.
   */
  entraNevOszlopok: string[] = [];
  entraNevIllesztes = true;
  entraTalalat = 0;
  /** A MÁR meglévő tanulókra talált címek: { oktazon, nev, regi, uj }. */
  entraParositas: any[] = [];
  /** Névre illesztéssel talált (nem azonosítóval) – a felület külön jelzi. */
  entraNevTalalat = 0;
  /** Névegyezés volt, de több jelölt – ezeket szándékosan kihagyjuk. */
  entraTobbertelmu = 0;
  entraMentes = false;
  entraMentesEredmeny: any = null;

  /*  Graph-lekérés a CSV helyett.
   *
   *  Az Entra admin portál CSV-exportja FIX oszlopkészletet ad: ami nincs benne (pl. az
   *  alkalmazotti azonosító), azt nem lehet vele kihozni. A Graph bármelyik mezőt megadja,
   *  és ugyanazzal az app-regisztrációval megy, amit a profilkép-lekérés használ.
   */
  graphFut = false;
  graphHiba = '';
  graphCsoport = '';
  graphCsoportok: any[] = [];
  graphForras = '';

  /* ── ÉVFOLYAM-ELTOLÁS ÉS OSZTÁLY-HOZZÁRENDELÉS ─────────────────────────
   *
   *  A KIR a MOSTANI állapotot adja: ha a következő tanévet készítjük elő, a fájlban
   *  9. évfolyam szerepel, de 10.-ként kell rögzíteni. Az eltolás ezt automatikusan
   *  elvégzi (az osztálynév kezdő számán is: „9z" → „10z"), a hozzárendelés-táblában
   *  pedig soronként felül lehet bírálni – mert nem minden osztály lép együtt
   *  (végzős évfolyam, „NA", „EK" és társai).
   */
  evfolyamEltolas = 0;
  osztalyTerkep: { [fajlErtek: string]: { eltolt: string; osztaly: string; evfolyam: number; kezi: boolean } } = {};

  /** Gondviselői fiók generálása az anya nevéből (a KIR csak azt adja). */
  szuloiFiokot = false;
  letezoSzulok: any[] = [];
  szuloEredmeny: any = null;
  /** Osztály nélküli tanulónál a szolgáltatás-sor kimarad (osztályhoz kötött adat). */
  szolgaltatasKihagyva = 0;
  /** Mit talált a KIR-olvasó a fájlban (fejlécsorok, mintasor) – a felület kiírja. */
  kirOlvasas: KirOlvasas = null;

  /**
   *  A `tanulo` tábla kötelező (NOT NULL, alapérték nélküli) oszlopai.
   *
   *  A KIR-export nem mindet tartalmazza. A hiányuk NEM akadálya az importnak: a sor
   *  bekerül, a mező üresen marad, és utólag pótolható – egy hiányzó születési hely
   *  miatt nem szabad kihagyni egy tanulót. Ezt a listát arra használjuk, hogy MENTÉS
   *  ELŐTT, soronként megmutassuk, mi fog hiányozni.
   */
  static readonly KOTELEZO: { oszlop: string; nev: string }[] = [
    { oszlop: 'Oktazon', nev: 'Oktatási azonosító' },
    { oszlop: 'Viselt név vezetéknév', nev: 'Viselt név vezetéknév' },
    { oszlop: 'Viselt név keresztnév', nev: 'Viselt név keresztnév' },
    { oszlop: 'Születési név vezetéknév', nev: 'Születési név vezetéknév' },
    { oszlop: 'Születési név keresztnév', nev: 'Születési név keresztnév' },
    { oszlop: 'Anyja neve vezetéknév', nev: 'Anyja neve vezetéknév' },
    { oszlop: 'Anyja neve keresztnév', nev: 'Anyja neve keresztnév' },
    { oszlop: 'Születési dátum', nev: 'Születési dátum' },
    { oszlop: 'Születési hely', nev: 'Születési hely' },
    { oszlop: 'Születési ország', nev: 'Születési ország' },
    { oszlop: '1. állampolgárság', nev: '1. állampolgárság' },
    { oszlop: 'TAJ szám', nev: 'TAJ szám' },
    { oszlop: 'Állandó lakcím irányítószám', nev: 'Állandó lakcím irányítószám' },
    { oszlop: 'Állandó lakcím település', nev: 'Állandó lakcím település' },
    { oszlop: 'Állandó lakcím közterület név', nev: 'Állandó lakcím közterület név' },
    { oszlop: 'Állandó lakcím közterület jelleg', nev: 'Állandó lakcím közterület jelleg' },
    { oszlop: 'Állandó lakcím házszám', nev: 'Állandó lakcím házszám' },
    { oszlop: 'Osztály', nev: 'Osztály' },
  ];

  /**
   *  Ami MIATT a sor egyáltalán nem menthető.
   *
   *  Egyetlen ilyen van: az oktatási azonosító, mert az a tanuló elsődleges kulcsa –
   *  nélküle nincs mit beszúrni. Minden más hiány pótolható adat, nem akadály.
   */
  private sorBlokkolo(t: any): string[] {
    return this.normalizeText(t['Oktazon'])
      ? [] : ['nincs oktatási azonosító – enélkül a tanuló nem menthető'];
  }

  /** Ami hiányzik, de a sor ettől még bekerül. Üres tömb = teljes sor. */
  private sorHiany(t: any): string[] {
    const hiany: string[] = [];
    for (const k of ImporttanulokComponent.KOTELEZO) {
      if (k.oszlop === 'Oktazon' || k.oszlop === 'Osztály') continue;   // külön kezeljük
      if (!this.normalizeText(t[k.oszlop])) hiany.push(k.nev);
    }
    const fajlOsztaly = this.normalizeText(t['Osztály']);
    if (!fajlOsztaly) hiany.push('Osztály – besorolás nélkül kerül be');
    else if (!this.celOsztaly(t)) {
      const terkep = this.osztalyTerkep[fajlOsztaly];
      hiany.push(`nincs hozzárendelve osztály ehhez: „${fajlOsztaly}"`
        + (terkep && terkep.eltolt !== fajlOsztaly ? ` (eltolással: „${terkep.eltolt}")` : '')
        + ' – besorolás nélkül kerül be');
    }
    return hiany;
  }

  /**
   *  A betöltött táblázat átvizsgálása – MENTÉS ELŐTT, hogy legyen mit javítani.
   *
   *  A hiányos sor NEM marad ki: bekerül, és itt megmutatjuk, mi hiányzik belőle.
   *  Kihagyni csak azt kell, amit tényleg nem lehet beszúrni (nincs azonosító).
   */
  ellenoriz() {
    const tetelek = [];
    let rendben = 0, hianyos = 0, blokkolt = 0;
    for (const t of this.excelData || []) {
      const blokkolo = this.sorBlokkolo(t);
      const hiany = blokkolo.length ? [] : this.sorHiany(t);
      if (blokkolo.length) blokkolt++;
      else if (hiany.length) hianyos++;
      else rendben++;
      if (blokkolo.length || hiany.length) {
        tetelek.push({
          oktazon: this.normalizeText(t['Oktazon']) || '(nincs)',
          nev: `${this.normalizeText(t['Viselt név vezetéknév'])} ${this.normalizeText(t['Viselt név keresztnév'])}`.trim(),
          osztaly: this.normalizeText(t['Osztály']),
          blokkolo, hiany,
        });
      }
    }
    const letezoSet = new Set((this.letezoTanulok || []).map((x) => String(x.oktazon)));
    const letezo = (this.excelData || []).filter((t) => letezoSet.has(this.normalizeText(t['Oktazon']))).length;
    this.ellenorzes = { rendben, hianyos, blokkolt, letezo, tetelek };
    return this.ellenorzes;
  }

  /** Az intézményben MÁR meglévő tanulók (a duplikátum-szűréshez). */
  letezoTanulok: any[] = [];

  /** A tanévben létező osztályok neve – a hibaüzenet ezt sorolja fel. */
  get osztalyNevek(): string {
    return (this.osztaly || []).map((o) => o.osztaly).join(', ');
  }

  constructor(private http: HttpClient, private data: DataService) { }

  private normalizeText(value: any): string {
    return String(value ?? '').trim();
  }

  private parseOsztalyAzonosito(value: any): string {
    const text = this.normalizeText(value);
    const match = text.match(/^\s*\d+\.\s+(.+)$/);
    return (match ? match[1] : text).trim();
  }

  private findOsztaly(value: any): any {
    const osztalyAzonosito = this.parseOsztalyAzonosito(value);
    return (this.osztaly || []).find((o) => this.normalizeText(o.osztaly) === osztalyAzonosito);
  }

  private parseEvfolyam(value: any): number {
    const text = this.normalizeText(value);
    const match = text.match(/^(\d+)/);
    return match ? Number(match[1]) : 0;
  }

  /* ══════════════════════════════════════════════════════════════════════
   *  ÉVFOLYAM-ELTOLÁS + OSZTÁLY-HOZZÁRENDELÉS
   * ═══════════════════════════════════════════════════════════════════ */

  /**
   *  Az eltolással kiigazított osztályérték.
   *
   *  A KIR-ben az évfolyam ÉS az osztály neve is hordozza a számot („9. 9/A"), ezért
   *  MINDKETTŐT léptetni kell: csak az előtagot mozgatva „10. 9/A" jönne ki, ami egyetlen
   *  létező osztályra sem illeszkedik – az illesztés ugyanis az előtag utáni részen megy.
   *    „9. 9/A" +1 → „10. 10/A"      „9z" +1 → „10z"      „9. A" +1 → „10. A"
   *  Szám nélküli osztályt (NA, EK) nem bánt.
   */
  private eltoltOsztalyNev(ertek: any): string {
    const szoveg = this.normalizeText(ertek);
    const eltolas = Number(this.evfolyamEltolas) || 0;
    if (!eltolas || !szoveg) return szoveg;
    const lep = (resz: string) =>
      resz.replace(/^(\s*)(\d+)/, (_m, ws, sz) => `${ws}${Number(sz) + eltolas}`);
    const bontas = szoveg.match(/^(\s*\d+\.\s+)(.+)$/);
    return bontas ? lep(bontas[1]) + lep(bontas[2]) : lep(szoveg);
  }

  /**
   *  A fájlban előforduló osztályértékek → cél osztály. Az eltolásból javaslunk, de a
   *  KÉZI választást megőrizzük: az eltolás egy szabály, a valóság nem mindig követi
   *  (végzős évfolyam, betűjelzés nélküli osztály).
   */
  osztalyTerkepEpit(ujraszamol = false) {
    const uj: any = {};
    for (const t of this.excelData || []) {
      const kulcs = this.normalizeText(t['Osztály']);
      if (!kulcs || uj[kulcs]) continue;
      const regi = this.osztalyTerkep[kulcs];
      if (regi?.kezi && !ujraszamol) { uj[kulcs] = regi; continue; }
      const eltolt = this.eltoltOsztalyNev(kulcs);
      const talalt = this.findOsztaly(eltolt);
      uj[kulcs] = {
        eltolt,
        osztaly: talalt?.id || '',
        evfolyam: this.parseEvfolyam(eltolt) || Number(talalt?.evfolyam) || 0,
        kezi: false,
      };
    }
    this.osztalyTerkep = uj;
  }

  /**
   *  Az eltolás megváltozott: újraszámoljuk a javaslatokat.
   *
   *  A KÉZI hozzárendelést megtartjuk. Korábban minden billentyűleütés a szám-mezőben
   *  visszaírta a javaslatot, tehát a kézzel beállított osztályok némán elvesztek –
   *  úgy tűnt, mintha a hibalista nem frissülne. Aki tényleg tiszta lappal akar
   *  indulni, annak ott a „Javaslatok újraszámolása" gomb.
   */
  eltolasValt() {
    this.osztalyTerkepEpit(false);
    this.ellenoriz();
  }

  /** Minden sor vissza a javaslatra – a kézi választásokat is eldobja (kérdés után). */
  terkepUjraszamol() {
    const kezi = Object.values(this.osztalyTerkep).filter((x: any) => x.kezi).length;
    if (kezi && !confirm(`${kezi} kézi hozzárendelés elveszik, és mindenhol az eltolásból `
      + 'számolt javaslat lesz. Folytatod?')) return;
    this.osztalyTerkepEpit(true);
    this.ellenoriz();
  }

  /** Kézi hozzárendelés – innentől ezt a sort az eltolás nem írja felül. */
  terkepValt(kulcs: string, osztalyId: string) {
    const sor = this.osztalyTerkep[kulcs];
    if (!sor) return;
    sor.osztaly = osztalyId;
    sor.kezi = true;
    const o = (this.osztaly || []).find((x) => String(x.id) === String(osztalyId));
    if (o && Number(o.evfolyam)) sor.evfolyam = Number(o.evfolyam);
    this.ellenoriz();
  }

  terkepEvfolyamValt(kulcs: string, ertek: any) {
    const sor = this.osztalyTerkep[kulcs];
    if (!sor) return;
    sor.evfolyam = Number(ertek) || 0;
    sor.kezi = true;
    this.ellenoriz();
  }

  /*  A hozzárendelés-tábla sorai.
   *
   *  KULCSOKAT adunk vissza, nem összemásolt objektumokat: egy getter minden
   *  változásfigyelési körben új objektumokat gyártana, az *ngFor pedig azonosság
   *  szerint követi a sorokat – így a legördülő és a szám-mező minden billentyűre
   *  újraépülne, azaz használhatatlan lenne. A sorokat a `trackBy` a kulcshoz köti.
   */
  get terkepKulcsok(): string[] {
    return Object.keys(this.osztalyTerkep).sort((a, b) => a.localeCompare(b, 'hu'));
  }
  terkepTrack = (_i: number, kulcs: string) => kulcs;

  /** Egy tanuló CÉL osztálya (a hozzárendelés dönt, nem a fájl nyers értéke). */
  private celOsztaly(t: any): any {
    const kulcs = this.normalizeText(t['Osztály']);
    const terkep = this.osztalyTerkep[kulcs];
    if (terkep?.osztaly) return (this.osztaly || []).find((o) => String(o.id) === String(terkep.osztaly));
    if (terkep) return null;              // ismert érték, de nincs hozzárendelve
    return this.findOsztaly(kulcs);       // a térkép még nem épült fel
  }

  /** Egy tanuló CÉL évfolyama (az eltolás/kézi érték szerint). */
  private celEvfolyam(t: any): number {
    const kulcs = this.normalizeText(t['Osztály']);
    const terkep = this.osztalyTerkep[kulcs];
    if (terkep) return Number(terkep.evfolyam) || 0;
    return this.parseEvfolyam(kulcs);
  }

  /* ══════════════════════════════════════════════════════════════════════
   *  ENTRA CSV → e-mail címek
   * ═══════════════════════════════════════════════════════════════════ */

  /** Csak a számjegyek – az azonosító hol nyersen, hol UPN-előtagként szerepel. */
  private csakSzam(v: any): string {
    return String(v ?? '').replace(/\D+/g, '');
  }

  /** Ékezet- és sorrendfüggetlen név-jelkészlet. A „dr" titulus nem azonosít. */
  private nevJelek(...reszek: any[]): Set<string> {
    const nyers = reszek.map((r) => this.normalizeText(r)).filter(Boolean).join(' ');
    const tiszta = nyers.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    return new Set(tiszta.split(/[^a-z0-9]+/).filter((x) => x && x !== 'dr'));
  }

  private halmazEgyezik(a: Set<string>, b: Set<string>): boolean {
    if (a.size !== b.size) return false;
    for (const x of a) if (!b.has(x)) return false;
    return true;
  }

  /** Minden jel megvan-e a másikban (a becenév-toldalék így sem zavar). */
  private reszhalmaza(kicsi: Set<string>, nagy: Set<string>): boolean {
    if (!kicsi.size) return false;
    for (const x of kicsi) if (!nagy.has(x)) return false;
    return true;
  }

  /** Az Entra-mező lehetséges azonosító-alakjai (nyers, UPN-előtag, csak számjegy). */
  private azonositoAlakok(v: any): string[] {
    const szoveg = this.normalizeText(v);
    if (!szoveg) return [];
    const elotag = szoveg.split('@')[0];
    return [...new Set([szoveg, elotag, this.csakSzam(elotag)].filter(Boolean))];
  }

  onEntraFile(event: any) {
    const file = event?.target?.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        // Az Entra-export CSV (UTF-8), de xlsx-et is elfogadunk – ugyanaz az olvasó.
        const wb = XLSX.read(e.target.result, { type: 'binary', raw: false });
        const ws = wb.Sheets[wb.SheetNames[0]];
        // KIR „Tanulók elérhetőségi adataik" sablon is jöhet ide: annak ugyanúgy
        // oktatási azonosító + e-mail a tartalma, csak KIR-fejléccel.
        const matrix = XLSX.utils.sheet_to_json(ws,
          { header: 1, raw: false, defval: null, blankrows: true }) as any[][];
        const kir = kirBeolvas(matrix, ['Tanuló oktatási azonosító']);
        this.entraSorok = kir.sorok.length
          ? kir.sorok
          : XLSX.utils.sheet_to_json(ws, { raw: false, defval: null }) as any[];
        this.entraOszlopok = this.entraSorok.length ? Object.keys(this.entraSorok[0]) : [];
        this.entraFajlNev = file.name;
        this.entraOszlopokKitalal();
        this.entraOsszefesul();
      } catch (err) {
        this.data.sendToast('Az Entra-fájlt nem sikerült beolvasni.', 'error');
      }
    };
    reader.readAsBinaryString(file);
  }

  /**
   *  Melyik oszlop az azonosító és melyik az e-mail?
   *
   *  Nem a nevekre hagyatkozunk (bérlőnként mások), hanem a TARTALOMRA: azonosító az,
   *  amelyik a legtöbb KIR-beli oktatási azonosítót eltalálja; e-mail az, amelyikben a
   *  legtöbb @ van. Így akkor is működik, ha az azonosító a belépési név előtagja.
   */
  private entraOszlopokKitalal() {
    // A fájlból ÉS a rendszerből is: az összerendelés KIR-fájl nélkül, a már felvett
    // tanulókra is működik – ez a gyakoribb eset, hiszen a diákok már bent vannak.
    const kirAzonositok = new Set([
      ...(this.excelData || []).map((t) => this.normalizeText(t['Oktazon'])),
      ...(this.letezoTanulok || []).map((t) => this.normalizeText(t.oktazon)),
    ].filter(Boolean));
    const kirSzamok = new Set([...kirAzonositok].map((x) => this.csakSzam(x)).filter(Boolean));

    let legjobbOszlop = '', legjobbTalalat = -1;
    let emailOszlop = '', emailDb = -1;
    let telefonOszlop = '', telefonDb = 0;
    for (const oszlop of this.entraOszlopok) {
      let talalat = 0, kukac = 0, telefon = 0;
      for (const sor of this.entraSorok) {
        const ertek = sor[oszlop];
        if (this.azonositoAlakok(ertek).some((a) => kirAzonositok.has(a) || kirSzamok.has(a))) talalat++;
        const szoveg = this.normalizeText(ertek);
        if (szoveg.includes('@')) kukac++;
        // Telefonszám: +36-tal kezdődik vagy 9-12 számjegy, és NEM oktatási azonosító.
        if (/^\+?\d[\d\s/-]{7,17}$/.test(szoveg) && !/^\d{11}$/.test(szoveg.replace(/\D/g, ''))) telefon++;
      }
      if (talalat > legjobbTalalat) { legjobbTalalat = talalat; legjobbOszlop = oszlop; }
      if (kukac > emailDb) { emailDb = kukac; emailOszlop = oszlop; }
      if (telefon > telefonDb) { telefonDb = telefon; telefonOszlop = oszlop; }
    }
    this.entraOktazonOszlop = legjobbTalalat > 0 ? legjobbOszlop : '';
    this.entraEmailOszlop = emailDb > 0 ? emailOszlop : '';
    this.entraTelefonOszlop = telefonDb > 0 ? telefonOszlop : '';

    /*  Névoszlopok: azok, amelyek a MI neveinket találják el.
     *
     *  Nem az oszlopnévre hagyatkozunk (bérlőnként más), hanem arra, hogy melyik
     *  oszlop tartalma egyezik a legtöbb saját tanulónk nevével. Több oszlop is
     *  lehet jó (teljes név, illetve vezeték- és keresztnév külön), ezért mindet
     *  megtartjuk, amelyik érdemi találatot ad.
     */
    const sajatNevek = [
      ...(this.excelData || []).map((t) => this.nevJelek(t['Viselt név vezetéknév'], t['Viselt név keresztnév'])),
      ...(this.letezoTanulok || []).map((t) => this.nevJelek(t.viselt_vez, t.viselt_ker)),
    ].filter((x) => x.size);
    this.entraNevOszlopok = [];
    if (sajatNevek.length) {
      const pontszam: { oszlop: string; db: number }[] = [];
      for (const oszlop of this.entraOszlopok) {
        if (oszlop === this.entraEmailOszlop || oszlop === this.entraTelefonOszlop) continue;
        let db = 0;
        for (const sor of this.entraSorok) {
          const jel = this.nevJelek(sor[oszlop]);
          if (jel.size < 2) continue;                       // egy szó még nem név
          if (sajatNevek.some((n) => this.halmazEgyezik(n, jel) || this.reszhalmaza(n, jel))) db++;
        }
        if (db) pontszam.push({ oszlop, db });
      }
      pontszam.sort((a, b) => b.db - a.db);
      this.entraNevOszlopok = pontszam.slice(0, 2).map((x) => x.oszlop);
    }
  }

  /** Az e-mail címek beírása a KIR-sorokba az azonosító alapján. */
  entraOsszefesul() {
    this.entraTalalat = 0;
    // Azonosító-oszlop nélkül is dolgozunk, ha névre tudunk illeszteni.
    if (!this.entraSorok.length || (!this.entraEmailOszlop && !this.entraTelefonOszlop)) return;
    if (!this.entraOktazonOszlop && !(this.entraNevIllesztes && this.entraNevOszlopok.length)) return;

    const index = new Map<string, { email: string; telefon: string }>();
    /*  Név-index: jelkészlet → elérhetőség. Ugyanaz a személy több oszlopból is
     *  bekerülhet (teljes név és vezeték+keresztnév), ezért SORONKÉNT gyűjtjük –
     *  különben egy embert két jelöltnek számolnánk, és mindenki „többértelmű" lenne.
     */
    const nevIndex: { jelkeszletek: Set<string>[]; email: string; telefon: string }[] = [];
    for (const sor of this.entraSorok) {
      const email = this.normalizeText(sor[this.entraEmailOszlop]);
      const telefon = this.entraTelefonOszlop ? this.normalizeText(sor[this.entraTelefonOszlop]) : '';
      if (!email && !telefon) continue;
      for (const alak of this.azonositoAlakok(sor[this.entraOktazonOszlop])) {
        if (!index.has(alak)) index.set(alak, { email, telefon });
      }
      if (this.entraNevIllesztes && this.entraNevOszlopok.length) {
        /*  OSZLOPONKÉNT külön jelkészlet, nem egybeolvasztva.
         *
         *  Ha a teljes nevet és a belépési nevet egy halmazba tennénk, minden
         *  emberhez odakerülne a tartomány is („europa2000", „hu"), és a PONTOS
         *  egyezés sosem jönne létre – minden találat a lazább részhalmaz-ágra
         *  csúszna. Így a pontos egyezés marad az elsődleges.
         */
        const keszletek = this.entraNevOszlopok
          .map((o) => this.nevJelek(sor[o])).filter((j) => j.size >= 2);
        if (keszletek.length) nevIndex.push({ jelkeszletek: keszletek, email, telefon });
      }
    }

    /**
     *  Egy név alapján EGYÉRTELMŰ találat, vagy semmi.
     *
     *  Előbb pontos jelkészlet-egyezés, utána részhalmaz (az Entrában gyakori a
     *  becenév a név mögött). Ha több jelölt van, NEM választunk – két azonos nevű
     *  gyerek e-mail címét felcserélni rosszabb, mint üresen hagyni.
     */
    const nevAlapjan = (jelek: Set<string>) => {
      if (!jelek.size) return null;
      const pontos = nevIndex.filter((x) => x.jelkeszletek.some((k) => this.halmazEgyezik(jelek, k)));
      if (pontos.length === 1) return pontos[0];
      if (pontos.length > 1) return null;
      const resz = nevIndex.filter((x) => x.jelkeszletek.some((k) => this.reszhalmaza(jelek, k)));
      return resz.length === 1 ? resz[0] : null;
    };
    this.entraNevTalalat = 0;
    this.entraTobbertelmu = 0;
    for (const t of this.excelData || []) {
      const azonosito = this.normalizeText(t['Oktazon']);
      let talalt: any = index.get(azonosito) || index.get(this.csakSzam(azonosito));
      if (!talalt) {
        talalt = nevAlapjan(this.nevJelek(t['Viselt név vezetéknév'], t['Viselt név keresztnév']));
        if (talalt) this.entraNevTalalat++;
      }
      if (talalt?.email) { t['E-mail cím'] = talalt.email; this.entraTalalat++; }
    }
    this.excelData = [...(this.excelData || [])];   // a táblázat frissüljön

    // A MÁR felvett tanulókra külön lista: ezeket nem az import írja, hanem egy
    // célzott frissítés – az importot nem kell újrafuttatni egy e-mail cím miatt.
    this.entraParositas = [];
    for (const t of this.letezoTanulok || []) {
      const azonosito = this.normalizeText(t.oktazon);
      let talalt: any = index.get(azonosito) || index.get(this.csakSzam(azonosito));
      let alap = 'azonosító';
      if (!talalt) {
        const jelek = this.nevJelek(t.viselt_vez, t.viselt_ker);
        talalt = nevAlapjan(jelek);
        alap = 'név';
        // Ha volt névegyezés, de nem egyértelmű, azt SZÁMOLJUK – a felhasználónak
        // tudnia kell, hány gyereknél maradt el az összerendelés emiatt.
        if (!talalt && jelek.size
            && nevIndex.some((x) => x.jelkeszletek.some((k) => this.reszhalmaza(jelek, k)))) {
          this.entraTobbertelmu++;
        }
      }
      if (!talalt) continue;
      const regi = this.normalizeText(t.email);
      const regiTel = this.normalizeText(t.telefon);
      const ujEmail = talalt.email && talalt.email.toLowerCase() !== regi.toLowerCase() ? talalt.email : '';
      const ujTel = talalt.telefon && talalt.telefon !== regiTel ? talalt.telefon : '';
      if (!ujEmail && !ujTel) continue;                       // nincs mit írni
      this.entraParositas.push({
        oktazon: azonosito,
        nev: this.normalizeText(t.full_name) || `${this.normalizeText(t.viselt_vez)} ${this.normalizeText(t.viselt_ker)}`.trim(),
        regi, uj: ujEmail, regiTel, ujTel, alap,
      });
    }
    this.entraParositas.sort((a, b) => String(a.nev).localeCompare(String(b.nev), 'hu'));
  }

  /**
   *  Az e-mail címek beírása a MÁR meglévő tanulókhoz.
   *
   *  Ez köti össze a diákot a Microsoft-fiókjával: a belépéskor a rendszer az e-mail
   *  címre is illeszt, tehát amint a cím bekerül, a diák a saját fiókjával belépve
   *  megtalálja magát – új import nélkül.
   */
  async emailekMentese() {
    if (!this.entraParositas.length) return;
    const felulir = this.entraParositas.filter((p) => p.regi).length;
    if (felulir && !confirm(`${felulir} tanulónak MÁS e-mail címe van rögzítve, ezeket felülírjuk. Folytatod?`)) return;
    this.entraMentes = true;
    this.entraMentesEredmeny = null;
    try {
      this.entraMentesEredmeny = await firstValueFrom(this.http.post('/api/import/tanulo-email', {
        intezmeny: this.sajatIntezmeny.intezmenyId,
        tetelek: this.entraParositas.map((p) => ({ oktazon: p.oktazon, email: p.uj, telefon: p.ujTel })),
      }));
      const r = this.entraMentesEredmeny;
      this.data.sendToast(`${r?.frissitve ?? 0} tanuló elérhetősége beírva.`
        + (r?.ismeretlen ? ` ${r.ismeretlen} azonosító nem ehhez az intézményhez tartozik.` : ''),
        r?.frissitve ? 'success' : 'warning');
      // Frissítjük a listát, hogy a párosítás ne kínálja fel újra ugyanazt.
      this.letezoTanulok = await firstValueFrom(
        this.http.get<any[]>('/api/nyilvantartas/tanulo/' + this.sajatIntezmeny.intezmenyId));
      this.entraOsszefesul();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az e-mail címek mentése nem sikerült.', 'error');
    } finally {
      this.entraMentes = false;
    }
  }

  /** Felhasználók lekérése a Microsoft Graph API-ból (CSV helyett vagy mellett). */
  async graphLekeres() {
    this.graphFut = true;
    this.graphHiba = '';
    try {
      const p = this.graphCsoport ? `?csoport=${encodeURIComponent(this.graphCsoport)}` : '';
      const r: any = await firstValueFrom(this.http.get(
        `/api/import/entra-felhasznalok/${this.sajatIntezmeny.intezmenyId}${p}`));
      this.entraSorok = r?.sorok || [];
      this.entraOszlopok = r?.oszlopok || [];
      this.entraFajlNev = '';
      this.graphForras = `Microsoft Graph – ${r?.db ?? 0} felhasználó`
        + (this.graphCsoport ? ` (csoport: ${this.graphCsoport})` : ' (teljes címtár)')
        + (r?.csonkolt ? ' – a lista csonkolva, szűkíts csoportra' : '');
      this.entraOszlopokKitalal();
      this.entraOsszefesul();
      if (!this.entraSorok.length) this.data.sendToast('A Graph nem adott vissza felhasználót.', 'warning');
    } catch (e: any) {
      // A Graph hibaüzenete megmondja, MIT kell javítani (engedély, titok, csoportnév) –
      // ezért nem cseréljük le egy általános szövegre.
      this.graphHiba = e?.error?.error || e?.message || 'A Graph-lekérés nem sikerült.';
    } finally {
      this.graphFut = false;
    }
  }

  /** A bérlő csoportjai – hogy ne kelljen kézzel begépelni a diák-csoport nevét. */
  async graphCsoportokBetolt() {
    this.graphHiba = '';
    try {
      const r: any = await firstValueFrom(this.http.get(
        `/api/import/entra-csoportok/${this.sajatIntezmeny.intezmenyId}`));
      this.graphCsoportok = r?.csoportok || [];
      if (!this.graphCsoportok.length) this.data.sendToast('Nincs csoport a bérlőben.', 'warning');
    } catch (e: any) {
      this.graphHiba = e?.error?.error || e?.message || 'A csoportok lekérése nem sikerült.';
    }
  }

  entraTorol() {
    this.entraSorok = []; this.entraOszlopok = []; this.entraFajlNev = '';
    this.entraOktazonOszlop = ''; this.entraEmailOszlop = ''; this.entraTelefonOszlop = ''; this.entraTalalat = 0;
    this.entraParositas = []; this.entraMentesEredmeny = null;
    this.graphForras = ''; this.graphHiba = '';
    const el = document.getElementById('entraFileRef') as HTMLInputElement;
    if (el) el.value = null;
  }

  private parseNyitottSzolgaltatas(value: any): { kezd: string | null; vege: string | null; szolg: string | null } | null {
    const text = this.normalizeText(value);
    if (!text) return null;

    const dateMatches = text.match(/\d{4}\.\d{2}\.\d{2}/g) || [];
    const parts = text.split(" - ").map((part) => part.trim()).filter(Boolean);

    return {
      kezd: dateMatches[0] ? moment(dateMatches[0], "YYYY.MM.DD").format("YYYY-MM-DD") : null,
      vege: dateMatches[1] ? moment(dateMatches[1], "YYYY.MM.DD").format("YYYY-MM-DD") : null,
      szolg: parts[2] || parts[1] || parts[0] || null,
    };
  }

  private birthDatePassword(value: any): string {
    const text = this.normalizeText(value);
    if (!text) return "Zenit123";

    const formatted = moment(text, ["YYYY-MM-DD", "YYYY. MM. DD.", "YYYY.MM.DD.", "YYYY.MM.DD"], true);
    const parsed = formatted.isValid() ? formatted : moment(text);
    return parsed.isValid() ? parsed.format("YYYYMMDD") : "Zenit123";
  }

  private keycloakUsername(row: any, fallback: string): string {
    const email = this.normalizeText(row["E-mail cím"] || row["email"]);
    return email || fallback;
  }

  private downloadKeycloakUsers(rows: any[], fileName: string, role: string) {
    const users = rows
      .map((row) => ({
        username: row.username,
        enabled: true,
        firstName: row.firstName,
        lastName: row.lastName,
        email: row.email || undefined,
        attributes: { jogkor: [role], locale: ["hu"] },
        credentials: [{ type: "password", value: row.password, temporary: true }],
        groups: [role],
        realmRoles: [role, "default-roles-master"],
      }))
      .filter((row) => row.username);

    const blob = new Blob([JSON.stringify({ users }, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  }

  async ngOnInit() { 
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    // Az importálás a MUNKATANÉVBE megy: ha az admin a következő tanévet készíti elő,
    // az osztálylistát is arra az évre kell kérni, különben minden sor "ismeretlen
    // osztály" miatt kimaradna.
    const akttev = await this.data.getMunkatanev()
    this.http.get("/api/osztaly/list/"+akttev+"/"+this.sajatIntezmeny.intezmenyId, {}).pipe(retry(3), catchError(e => {        // need to capture the 'e' here...
      this.handleError(e, this.data);   // pass to your function
      return EMPTY;          // and return empty
    })).subscribe(d => {
      this.osztaly = d
      
    });
    // A meglévő tanulók a KIR-fájl NÉLKÜLI e-mail-összerendeléshez is kellenek
    // (és a duplikátum-szűréshez, ha jön fájl).
    try {
      this.letezoTanulok = await firstValueFrom(
        this.http.get<any[]>('/api/nyilvantartas/tanulo/' + this.sajatIntezmeny.intezmenyId));
    } catch (e) { this.letezoTanulok = []; }
  }

  async uploadData() {
    // Először ellenőrzés: ha egyetlen sor sem importálható, nincs értelme elküldeni –
    // és a felhasználónak meg kell tudnia, MIÉRT nem.
    const e = this.ellenoriz();
    const meno = e.rendben + e.hianyos;
    if (!meno) {
      this.data.sendToast(`Egyetlen sor sem importálható (${e.blokkolt} sorban nincs `
        + `oktatási azonosító).`, "error");
      return;
    }
    // A hiányos sor MEGY – csak szólunk róla. Kimaradni csak az azonosító nélküli tud.
    if (e.blokkolt && !confirm(`${e.blokkolt} sorban nincs oktatási azonosító, ezek `
        + `KIMARADNAK (enélkül nem menthető a tanuló). A maradék ${meno} sor menjen?`)) {
      return;
    }
    this.uploading = true;
    this.eredmeny = null;
    this.szolgaltatasKihagyva = 0;
    this.data.showLoading("Állományok ellenőrzése és feltöltés...")
    let kuld = [];
    kuld["tanulo"] = [];
    kuld["tanulo_jogviszony"] = [];
    kuld["tanulo_szolgaltatas"] = [];
    const keycloakUsers = [];
    this.hibassorok = [];
    const szuloKuld = { szulo: [], csalad: [], tanulo_szulo: [] };
    for await(let t of this.excelData){
      const osztaly = this.celOsztaly(t);
      // Csak az azonosító nélküli sor marad ki: minden más hiány pótolható adat, a
      // tanulót attól még be kell húzni (osztály nélkül is – a besorolás utólag pótolható).
      if (this.sorBlokkolo(t).length) {
        this.hibassorok.push(t)
        continue
      }
      let adid = t["Oktazon"];
      const keycloakUsername = this.keycloakUsername(t, String(adid));
      kuld["tanulo"].push({
        adid: adid,
        oktazon: t["Oktazon"],
        viselt_vez: t["Viselt név vezetéknév"],
        viselt_ker: t["Viselt név keresztnév"],
        szul_vez: t["Születési név vezetéknév"],
        szul_ker: t["Születési név keresztnév"],
        anya_vez: t["Anyja neve vezetéknév"],
        anya_ker: t["Anyja neve keresztnév"],
        viselt_elo: t["Viselt név előtag"],
        szul_elo: t["Születési név előtag"],
        anya_elo: t["Anyja neve előtag"],
        szul_datum: t["Születési dátum"],
        szul_hely: t["Születési hely"],
        szul_orszag: t["Születési ország"],
        allampolgar_1: t["1. állampolgárság"],
        allampolgar_2: t["2. állampolgárság"],
        nem: t["Nem"] == "Férfi" ? "1" : "0",
        taj: t["TAJ szám"],
        all_cim_irsz: t["Állandó lakcím irányítószám"],
        all_cim_telepules: t["Állandó lakcím település"],
        all_cim_kozter: t["Állandó lakcím közterület név"],
        all_cim_kozter_jelleg: t["Állandó lakcím közterület jelleg"],
        all_cim_hsz: t["Állandó lakcím házszám"],
        all_cim_pontos: t["Állandó lakcím pontosítás"],
        tart_cim_irsz: t["Tartózkodási cím irányítószám"],
        tart_cim_telepules: t["Tartózkodási cím település"],
        tart_cim_kozter: t["Tartózkodási cím közterület név"],
        tart_cim_kozter_jelleg: t["Tartózkodási cím közterület jelleg"],
        tart_cim_hsz: t["Tartózkodási cím házszám"],
        tart_cim_pontos: t["Tartózkodási cím pontosítás"],
        tankot_vege: t["Tankötelezettség vége"],
        tankot_telj: t["Tankötelezettséget teljesítő"] == "I" ? 1 : 0,
        sni: t["Sajátos nevelési igényű"] == "I" ? 1 : 0,
        btmn: t["Beilleszkedéssel, tanulási, magatartási nehézséggel küzd"] == "I" ? 1 : 0,
        diakszam: t["Érvényes diákigazolvány száma"],
        // Az e-mail az Entra-exportból jön (a KIR nem tartalmazza) – ha nincs, marad üres.
        email: this.normalizeText(t["E-mail cím"] || t["email"]) || null,
        intezmeny: this.sajatIntezmeny.intezmenyId
        //osztaly: t["Osztály"],
      });
      kuld["tanulo_jogviszony"].push({
        statusz: t["Jogviszony státusza"] == "aktív" ? 1 : 0,
        kezdete: t["Jogviszony kezdete"],
        vege: t["Jogviszony megszűnte"],
        varh_vege: t["Jogviszony (várható) befejezése"],
        vendeg: t["Vendégtanuló"] == "I" ? 1 : 0,
        egyeni_tanrend: t["Egyéni munkarend"] == "I" ? 1 : 0,
        ideiglenes: t["Ideiglenes óvodai/ideiglenes vendégtanulói jogviszony"] == "I" ? 1 : 0,
        osztaly: osztaly?.id || null,
        evfolyam: this.celEvfolyam(t),
        oktazon: adid,
        intezmeny: this.sajatIntezmeny.intezmenyId
        });
      const nyitottSzolgaltatas = this.parseNyitottSzolgaltatas(t["Nyitott szolgáltatások"]);
      /*  A szolgáltatás-sor OSZTÁLYHOZ kötött: a tanulo_szolgaltatas.osztaly nem lehet
       *  üres. Ha a tanulónak nincs osztálya hozzárendelve, a szolgáltatás kimarad – a
       *  TANULÓ viszont bemegy. Enélkül a beszúrás elhasalt, és vele bukott az egész
       *  import, pedig csak egy kísérő adatról van szó.
       */
      if ((nyitottSzolgaltatas?.kezd || nyitottSzolgaltatas?.szolg) && !osztaly) {
        this.szolgaltatasKihagyva++;
      } else if (nyitottSzolgaltatas?.kezd || nyitottSzolgaltatas?.szolg) {
        kuld["tanulo_szolgaltatas"].push({
        tanulo: adid,
        kezd: nyitottSzolgaltatas.kezd,
        vege: nyitottSzolgaltatas.vege,
        szolg: nyitottSzolgaltatas.szolg,
        osztaly: osztaly?.id || null,
        evfolyam: this.celEvfolyam(t),
        intezmeny: this.sajatIntezmeny.intezmenyId
        });
      }
      keycloakUsers.push({
        username: keycloakUsername,
        firstName: t["Viselt név keresztnév"],
        lastName: t["Viselt név vezetéknév"],
        email: this.normalizeText(t["E-mail cím"] || t["email"]),
        password: this.birthDatePassword(t["Születési dátum"]),
      });

      if (this.szuloiFiokot) this.szuloSorHozzaad(szuloKuld, t, String(adid));

    };
    if (this.generateKeycloakImport) {
      this.downloadKeycloakUsers(keycloakUsers, 'tanulo-keycloak-users.json', 'tanulo');
    }
    if (this.szuloiFiokot && this.generateKeycloakImport) {
      this.downloadKeycloakUsers(
        szuloKuld.szulo.map((sz: any) => ({
          username: sz.username, firstName: sz.ker, lastName: sz.vez,
          email: '', password: 'Zenit123',
        })), 'gondviselo-keycloak-users.json', 'gondviselo');
    }
    console.log(kuld)
    this.http.post("/api/import/tanulo", [kuld["tanulo"],kuld["tanulo_jogviszony"],kuld["tanulo_szolgaltatas"]]).pipe(retry(3), catchError(e => {        // need to capture the 'e' here...
      this.handleError(e, this.data);   // pass to your function
      return EMPTY;          // and return empty
    })).subscribe({ next: (d: any) => {

      this.data.hideLoading()
      this.uploading = false;
      this.eredmeny = d;
      console.log(d)

      // A korábbi `d.toString().indexOf("OK")` MINDIG igaz volt (-1 is igaz), ezért a
      // képernyő akkor is sikert jelentett, ha egyetlen sor sem ment be.
      if (d?.error || !d?.ok) {
        this.data.sendToast("Hiba történt a feldolgozás során: "
          + (d?.error?.sqlMessage || d?.error?.message || d?.error || "ismeretlen hiba"), "error");
        return;
      }
      // A három tábla külön áll vagy bukik: ha az egyik elhasalt, azt külön mondjuk el,
      // de a többi eredményét nem tüntetjük el.
      if (d?.hibak?.length) {
        this.data.sendToast('Egy rész nem ment be: ' + d.hibak.join(' | '), 'warning');
      }
      const uj = Number(d?.tanulo?.affectedRows || 0);
      const kihagyott = kuld["tanulo"].length - uj;
      this.data.sendToast(`Kész: ${uj} tanuló mentve`
        + (kihagyott > 0 ? `, ${kihagyott} már létezett (kimaradt)` : '')
        + (e.hianyos ? `, ${e.hianyos} hiányos adattal ment be` : '')
        + (this.szolgaltatasKihagyva ? `, ${this.szolgaltatasKihagyva} szolgáltatás-sor osztály híján kimaradt` : '')
        + (this.hibassorok.length ? `, ${this.hibassorok.length} azonosító nélküli sor kihagyva` : ''), "success");

      // A gondviselői fiókok CSAK a tanulók után mehetnek: a tanulo_szulo a tanuló
      // oktatási azonosítójára hivatkozik, ami addig még nem létezik.
      if (this.szuloiFiokot && szuloKuld.szulo.length) this.szulokatLetrehoz(szuloKuld);
    }, error: () => this.data.hideLoading() });




  }
  /**
   *  Gondviselői fiók a tanuló ANYJA nevéből.
   *
   *  A KIR csak az anya nevét adja (sem e-mail, sem születési adat), és ez elég is:
   *  a fiók a belépéshez és a gyerekhez kötéshez kell. A felhasználónév a KIR
   *  gondviselői azonosító-alakja (`<oktatási azonosító>G01`), mert a belépés is ezt
   *  ismeri fel; a lakcímet a gyerekétől vesszük át.
   *
   *  Akinek MÁR van ilyen felhasználóneve, azt kihagyjuk – a szülő-import felülíró
   *  módban ír, és egy meglévő gondviselő adatait nem szabad egy generált sorral
   *  elfednünk.
   */
  private szuloSorHozzaad(kuld: any, t: any, oktazon: string) {
    const vez = this.normalizeText(t['Anyja neve vezetéknév']);
    const ker = this.normalizeText(t['Anyja neve keresztnév']);
    if (!vez || !ker) return;                       // név nélkül nincs fiók
    const username = `${oktazon}G01`;
    if ((this.letezoSzulok || []).some((sz) => this.normalizeText(sz.username) === username)) return;
    if (kuld.szulo.some((sz: any) => sz.username === username)) return;

    const irsz = Number(this.csakSzam(t['Állandó lakcím irányítószám'])) || null;
    const cim = [t['Állandó lakcím közterület név'], t['Állandó lakcím közterület jelleg'],
                 t['Állandó lakcím házszám']].map((x) => this.normalizeText(x)).filter(Boolean).join(' ');

    kuld.szulo.push({
      elo: this.normalizeText(t['Anyja neve előtag']) || null,
      vez, ker,
      torv_kepv: 1,
      szul_hely: null, szul_ido: null,
      username,
      email: null, telefon: null,
      irsz, telepules: this.normalizeText(t['Állandó lakcím település']) || null, cim: cim || null,
      tart_irsz: null, tart_telepules: null, tart_cim: null,
      intezmeny: this.sajatIntezmeny.intezmenyId,
      ig_tipus: null, ig_szam: null,
      jogkor: '["gondviselo"]',
      anya_vez: null, anya_ker: null,
    });
    kuld.csalad.push({ users: JSON.stringify([oktazon, username]) });
    kuld.tanulo_szulo.push({ tanulo: oktazon, szulo: username, rokonsag: 1 });
  }

  /** A generált gondviselők beküldése (a tanulók mentése után). */
  private szulokatLetrehoz(kuld: any) {
    this.http.post('/api/import/szulo', [kuld.szulo, kuld.csalad, kuld.tanulo_szulo])
      .subscribe({
        next: (d: any) => {
          this.szuloEredmeny = d;
          if (d?.error) {
            this.data.sendToast('A gondviselői fiókok létrehozása hibára futott: '
              + (d.error?.sqlMessage || d.error?.message || d.error), 'error');
            return;
          }
          // A szerver a kötésnél `inserted`/`skipped`-et ad vissza, nem affectedRows-t.
          const kotes = Number(d?.tanulo_szulo?.inserted || 0);
          const meglevo = Number(d?.tanulo_szulo?.skipped || 0);
          this.data.sendToast(`${kuld.szulo.length} gondviselői fiók létrehozva, `
            + `${kotes} gyerekhez kötve`
            + (meglevo ? `, ${meglevo} kapcsolat már megvolt` : '')
            + ' (felhasználónév: oktatási azonosító + G01).', 'success');
        },
        error: () => this.data.sendToast('A gondviselői fiókok létrehozása nem sikerült.', 'error'),
      });
  }

  handleError(error: HttpErrorResponse, data) {

    data.hideLoading()

    data.sendToast("Nem sikerült elküldeni a kérést!", "error")
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }

  onFileChange(event: any) {
    const file = event.target?.files[0];
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const workbook = XLSX.read(e.target.result, { type: 'binary', cellDates: true });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      /*  A KIR-export nem „egy fejléc + adatsorok": fejléc, MINTASOR („Minta Géza"),
       *  fejléc újra, adat – és a táblázat VÉGÉN még egyszer fejléc. A szokásos
       *  beolvasás mindezt adatsorként hozta be. A KIR-olvasó megtalálja a bevezető
       *  fejléc-blokkot, és a mintasort meg az ismételt fejléceket kihagyja.
       */
      const matrix = XLSX.utils.sheet_to_json(worksheet,
        { header: 1, raw: false, defval: null, blankrows: true }) as any[][];
      this.kirOlvasas = kirBeolvas(matrix, ['Oktazon', 'Viselt név vezetéknév']);
      // Ha nem KIR-fájl (nincs meg a két kulcsoszlop), marad a régi, egyszerű olvasás.
      this.excelData = this.kirOlvasas.sorok.length
        ? this.kirOlvasas.sorok
        : XLSX.utils.sheet_to_json(worksheet, { raw: true, defval: null }) as any[];
      // A duplikátum-szűrés a MEGLÉVŐ TANULÓK oktatási azonosítói alapján megy. Eddig az
      // ÁLLOMÁNY (dolgozók) listáját nézte, ami sosem egyezett – így a „ne írja felül"
      // beállítás gyakorlatilag nem szűrt semmit.
      const oktazonSet = new Set((this.letezoTanulok || []).map(item => String(item.oktazon)));
      // Az üres azonosítójú sor nem menthető (a tanulo.oktazon elsődleges kulcs), és
      // `!= ""` nem fogta meg a null-t – az ilyen sor eddig 0-s azonosítóval ment volna be.
      this.excelData = this.excelData.filter(item => String(item["Oktazon"] ?? "").trim() !== "");
      if (!this.overwrite)
        this.excelData = this.excelData.filter(item => !oktazonSet.has(String(item["Oktazon"]).trim()));
      /*  A KIR „2012. 01. 10." alakot ír. A korábbi szabad kezű elemzés a böngésző
       *  saját dátum-értelmezésére esett vissza, ami böngészőnként MÁS: ugyanaz a fájl
       *  más gépen más (vagy érvénytelen) dátumot adott volna. Most felsorolt alakok.
       */
      for (const t of this.excelData) {
        for (const mezo of ['Születési dátum', 'Jogviszony kezdete', 'Jogviszony megszűnte',
                            'Jogviszony (várható) befejezése', 'Tankötelezettség vége']) {
          t[mezo] = kirDatum(t[mezo], moment);
        }
      }
      // A hozzárendelés a fájl osztályértékeiből épül; ha már van Entra-fájl, az
      // e-mail címeket rögtön hozzá is fésüljük.
      this.osztalyTerkepEpit(true);
      if (this.entraSorok.length) { this.entraOszlopokKitalal(); this.entraOsszefesul(); }
      this.ellenoriz();
    };
    reader.readAsBinaryString(file);
  }



  files: any[] = [];

  /**
   * on file drop handler
   */
  onFileDropped($event) { alert("Csak a tallózás támogatott jelenleg!")
    //this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(event) {
console.log(event)
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files) {
      const files: any = inputElement.files;
      // Now you can handle the files as needed
      this.prepareFilesList(files, event);
    }

  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files = [];
    this.excelData = [];
    (<HTMLInputElement>document.getElementById("fileDropRef")).value = null;
    this.cdis = false;
    //this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number, event) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            this.onFileChange(event);
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1, event);
          } else {
            this.files[index].progress += 5;
          }
        }, 20);
      }
    }, 100);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  async prepareFilesList(files: Array<any>, event = null) {
    //for (const item of files) {
    this.cdis = true;
    const item = files[0]
    item.progress = 0;
    if (item.name.indexOf(".xls") != -1) {
      this.files[0] = item;
      const intezmeny = (await this.data.getFromStorage("sajatIntezmeny")).intezmenyId;
      this.letezoTanulok = await firstValueFrom(
        this.http.get<any[]>("/api/nyilvantartas/tanulo/" + intezmeny));
      // A meglévő gondviselők: a generálás nem írhat felül egy már felvett szülőt.
      try {
        this.letezoSzulok = await firstValueFrom(
          this.http.get<any[]>("/api/nyilvantartas/szulo/" + intezmeny));
      } catch (e) { this.letezoSzulok = []; }
      this.uploadFilesSimulator(0, event);
    } else {
      alert("Csak Excel fájlt lehet feltölteni!");
      this.deleteFile(0)
    }

    //}

  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }




}
